<script>
import common from '@/mixins/common.vue';
import { mapActions } from 'vuex';

export default {
  name: 'FinatradeMotoPrint',
  mixins: [common],
  data(){
    return {
      caseId: '',
      itemDetail: null,
    }
  },
  created() {
    const caseId = this.$route.query.caseId;
    if(caseId && caseId !==''){
      this.caseId = caseId;
      this.loadData();
    }
  },
  methods: {
    ...mapActions(['loadFastFinanceInfo']),
    async loadData(){
      try {
        const res = await this.loadFastFinanceInfo({ caseId: this.caseId});
        const result = res.data;
        console.log(`loadFastFinanceInfo = ${JSON.stringify(result)}` );
        if(result && result.statusCode === 0){
          this.itemDetail = result.data;
        } else {
          this.showMessageDialog(result ? result.message : '載入失敗！');
        }
      } catch (e) {
        console.log(`loadFastFinanceInfo error ` , e);
        this.showMessageDialog(`複製失敗`);
      }
    }
  }
};
</script>

<template>
<div>
  <div class="wrapper" v-if="itemDetail">
    <div class="page page1">
      <div class="header">
        <h1>遠東國際商業銀行汽車貸款申請書</h1>
        <span class="na">業務：王先生</span>
      </div><!--header-->
      <div class="hd1">
        案件種類：
        <span class="checkbox"><input type="checkbox" disabled=""></span>中古車
        <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>原融
        <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>原融代償
        <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>借新還舊
        <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>新車
        <span class="hd-date">
              申請日：<span class="y">{{ new Date(itemDetail.createdDate).getFullYear() }}</span>年<span class="m">{{ new Date(itemDetail.createdDate).getMonth()+1 }}</span>月<span class="d">{{ new Date(itemDetail.createdDate).getDate() }}</span>日
            </span><!--he-date-->
        <span class="hd-nb">
              合迪合約編號：
            </span><!--he-date-->
      </div><!--hd1-->
      <div class="area1">
        <table class="table table1">
          <tbody>
          <tr>
            <td width="390px">
              認證聯盟：
              <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>SAVE
              <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>SUM
              <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>HOT
              <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>順心
              <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>公會認證
              <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>無
              <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>私人買賣
            </td>
            <td width="198px">車商名稱：<span></span></td>
            <td>聯絡電話：<span>0987654321</span></td>
          </tr>
          </tbody>
        </table><!--table1-->
        <table class="table table2">
          <tbody>
          <tr>
            <th rowspan="2" width="24px">標的物</th>
            <td width="130px">廠牌：<span>廠牌名稱</span></td>
            <td width="130px">車型：<span>車型名稱</span></td>
            <td colspan="2" >出廠年/月：<span></span></td>
            <td rowspan="2" width="90px" style="padding-top:0;"><span class="checkbox"><input type="checkbox" disabled=""></span>擔保物提供人非借款人，與其關係:<span>父子</span></td>
            <td width="157px">買賣車價：<span class="mn">100,000</span>萬</td>
          </tr>
          <tr>
            <td>車號：<span>8888-AA</span></td>
            <td>CC 數：<span>2000</span></td>
            <td>車色：<span>銀色</span></td>
            <td width="125px" style="padding:4px 2px;">
              <span style="display: inline-block; float: left;">燃料種類：</span>
              <span style="display: inline-block;">
                      <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>汽油
                      <span class="checkbox" style="margin-left:7px;"><input type="checkbox" disabled=""></span>電能
                      <br/>
                      <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>油/電
                      <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>柴油
                    </span>
            </td>
            <td>權威車價：<span class="mn"></span>萬</td>
          </tr>
          </tbody>
        </table><!--table2-->
        <table class="table table3">
          <tbody>
          <tr>
            <td width="200px">專案名稱：<span></span></td>
            <td width="190px">貸款金額：<span>{{ itemDetail.needAmount }}</span></td>
            <td>期數：<span></span></td>
            <td width="157px">期付款：<span></span></td>
          </tr>
          </tbody>
        </table>
        <table class="table table4">
          <tbody>
          <tr>
            <th rowspan="3" width="24px">公司戶</th>
            <td width="230px">公司名稱：<span>{{ itemDetail.company }}</span></td>
            <td width="150px">統一編號：<span></span></td>
            <td width="184px">設立日期：
<!--              <span class="nb">2023</span>/<span class="nb">12</span>/<span class="nb">30</span>-->
            </td>
            <td>行業別：
              <span></span>
            </td>
            <td>員工數：<span></span>人</td>
          </tr>
          <tr class="tr">
            <td colspan="3">
              登記地址：
              <span>{{ itemDetail.companyPost }}</span>
              <span style="display:inline-block; width: 360px;">{{ itemDetail.companyCity }}{{ itemDetail.companyArea }}{{ itemDetail.companyAddress }}</span>
              電話：<span>{{ itemDetail.companyPhone }}</span>
            </td>
            <td width="155px" colspan="2">年營業額：<span class="mn1"></span>萬</td>
          </tr>
          <tr class="tr">
            <td colspan="3">
              營業通訊地址:：
              <span>{{ itemDetail.companyPost }}</span>
              <span style="display:inline-block; width: 337px;">{{ itemDetail.companyCity }}{{ itemDetail.companyArea }}{{ itemDetail.companyAddress }}</span>
              電話：<span>{{ itemDetail.companyPhone }}</span>
            </td>
            <td width="155px" colspan="2">資本額：<span class="mn2"></span>萬</td>
          </tr>
          </tbody>
        </table>
      </div><!--area1-->
      <div class="area2">
        <div class="tit">個人戶申請或公司負責人</div>
        <div class="con">
          <table class="table table5">
            <tbody>
            <tr>
              <td width="175px">姓名：<span>{{ itemDetail.name }}</span></td>
              <td width="175px">身分證字號：<span>{{ itemDetail.memberId }}</span></td>
              <td  width="55px">
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>男
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>女
              </td>
              <td  width="110px">
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>已婚
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>未婚
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>離婚
              </td>
              <td>
                生日：
<!--                <span class="nb">2023</span>/<span class="nb">12</span>/<span class="nb">30-->
              </span>
              </td>
              <td  width="90px" style="border:2px solid #000;">
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>負責人兼保證人
              </td>
            </tr>
            </tbody>
          </table><!--table5-->
          <table class="table table6">
            <tbody>
            <tr>
              <td>
                戶籍地址：
                <span>{{ itemDetail.residencePost }}</span>
                <span style="display:inline-block; width: 360px;">{{ itemDetail.residenceCity }}{{ itemDetail.residenceArea }}{{ itemDetail.residenceAddress }}</span>
                電話：<span>{{ itemDetail.phone }}</span>
              </td>
              <td width="170px">身份證請領資料：
<!--                <span class="nb">2023</span>/<span class="nb">12</span>/<span class="nb">30</span>-->
              </td>
            </tr>
            <tr>
              <td>
                通訊地址：
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>同戶籍
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>其他
                <span style="margin-left:10px;">{{ itemDetail.homePost }}</span>
                <span style="display:inline-block; width: 270px; ">{{ itemDetail.homeCity }}{{ itemDetail.homeArea }}{{ itemDetail.homeAddress }}</span>
                電話：<span>{{ itemDetail.homePost }}</span>
              </td>
              <td>行動：<span>{{ itemDetail.homePhone }}</span></td>
            </tr>
            </tbody>
          </table><!--table6-->
          <table class="table table7">
            <tbody>
            <tr>
              <td>
                現住房屋已<span class="y">20</span>年
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>自有\配偶所有
                <span class="checkbox" style="margin-left:0px;"><input type="checkbox" disabled=""></span>父母/子女所有
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>租賃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他(<span class="others1"></span>)
              </td>
              <td width="245px">學歷
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>博士
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>研究所
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>大專
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>高中職
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>初中及以下
              </td>
              <td width="110px">
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>領有殘障手冊<br/>
<!--                (<span class="others2"></span>)-->

              </td>
            </tr>
            </tbody>
          </table><!--table7-->
          <table class="table table8">
            <tbody>
            <tr>
              <td width="228px">
                服務單位：<span>服務單位</span>
              </td>
              <td width="380px">
                服務單位性質：
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>上市/櫃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>未上市/櫃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>獨資
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>軍公教
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他
              </td>
              <td>
                行業別：<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table8-->
          <table class="table table9">
            <tbody>
            <tr>
              <td width="140px">
                職稱：<span>{{ itemDetail.companyTitle }}</span>
              </td>
              <td width="88px">
                年資：<span>{{ itemDetail.workYear }}年</span>
              </td>
              <td width="150px">
                月收入：<span>{{ itemDetail.salary }}</span>
              </td>
              <td>
                E-mail：<span>{{ itemDetail.email }}</span>
              </td>
            </tr>
            </tbody>
          </table><!--table9-->
          <table class="table table10">
            <tbody>
            <tr>
              <td width="480px">
                服務地址：
                <span>{{ itemDetail.companyPost }}</span>{{ itemDetail.companyCity }}{{ itemDetail.companyArea }}{{ itemDetail.companyAddress }}
              </td>
              <td>
                電話：<span style="display: inline-block; width:107px;">{{ itemDetail.companyPhone }}</span>
                分機<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table10-->
        </div>
      </div><!--area2-->
      <table class="table table11">
        <tbody>
        <tr>
          <td width="145px">
            實際用車人：<span></span>
          </td>
          <td width="325px">
            通訊地址：
            <span></span>
          </td>
          <td width="165px">
            電話：<span></span>
          </td>
          <td>
            關係：<span></span>
          </td>
        </tr>
        </tbody>
      </table><!--table11-->
      <div class="area3">
        <div class="tit">付款方式</div>
        <div class="con">
          <table class="table table12">
            <tbody>
            <tr>
              <td width="350px">
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>銀行自動扣繳
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>郵局自動扣繳
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>ATM
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>超商
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>ACH
              </td>
              <td>
                帳單類型
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>電子帳單
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>紙本帳單
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <b>繳款單寄送處：</b>
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>戶籍地
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>通訊地
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>公司
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>其他
<!--                <span style="margin-left: 10px;">000</span>高雄市大寮區自由路100號-->
                <span style="margin-left: 10px;"></span>
              </td>
            </tr>
            </tbody>
          </table><!--table12-->
          <table class="table table13">
            <tbody>
            <tr>
              <td>
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>支票付款
                (付款行：<span class="name"></span>銀行<span class="name"></span>分行
              </td>
            </tr>
            </tbody>
          </table><!--table13-->
          <table class="table table14">
            <tbody>
            <tr>
              <td width="180px">帳號：<span></span></td>
              <td width="155px">發票人：<span></span></td>
              <td width="155px">發票日：<span></span></td>
              <td>往來情形：<span></span></td>
            </tr>
            </tbody>
          </table><!--table14-->
        </div><!--con-->
      </div><!--area3-->
      <div class="area4">
        <div class="tit">保證人一</div>
        <div class="con">
          <table class="table table15">
            <tbody>
            <tr>
              <td width="120px">姓名：<span></span></td>
              <td width="200px">身分證字號：<span></span></td>
              <td  width="50px">
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>男
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>女
              </td>
              <td  width="105px">
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>已婚
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>未婚
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他
              </td>
              <td>
                生日：
<!--                <span class="nb">2023</span>/<span class="nb">12</span>/<span class="nb">30</span>-->
              </td>
              <td  width="110px" >關係：<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table15-->
          <table class="table table16">
            <tbody>
            <tr>
              <td>
                戶籍地址：
                <span></span>
                <span style="display:inline-block; width: 365px;"></span>
                電話：<span></span>
              </td>
              <td width="142px">身份證請領資料：
<!--                <span class="nb">2023</span>/<span class="nb">12</span>/<span class="nb">30</span>-->
              </td>
            </tr>
            <tr>
              <td>
                通訊地址：
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>同戶籍
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>其他
                <span style="margin-left:10px;"></span>
                <span style="display:inline-block; width: 275px; "></span>
                電話：<span></span>
              </td>
              <td>行動：<span></span></td>
            </tr>
            </tbody>
          </table><!--table16-->
          <table class="table table17">
            <tbody>
            <tr>
              <td>
                現住房屋已<span class="y">{{ itemDetail.liveYear }}</span>年
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>自有\配偶所有
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>父母/子女所有
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>租賃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他(<span class="others1"></span>)
              </td>
              <td width="245px">學歷
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>博士
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>研究所
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>大專
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>高中職
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>初中及以下
              </td>
              <td width="110px">
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>領有殘障手冊<br/>
                (<span class="others2"></span>)

              </td>
            </tr>
            </tbody>
          </table><!--table17-->
          <table class="table table18">
            <tbody>
            <tr>
              <td width="252px">
                服務單位：<span></span>
              </td>
              <td >
                服務單位性質：
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>上市/櫃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>未上市/櫃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>獨資
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>軍公教
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他
              </td>
              <td width="110px">
                行業別：<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table18-->
          <table class="table table19">
            <tbody>
            <tr>
              <td width="140px">
                職稱：<span></span>
              </td>
              <td width="112px">
                年資：<span></span>
              </td>
              <td width="120px">
                月收入：<span></span>
              </td>
              <td>
                E-mail：<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table19-->
          <table class="table table20">
            <tbody>
            <tr>
              <td width="446px">
                服務地址：
                <span></span>
              </td>
              <td>
                電話：<span style="display: inline-block; width:107px;"></span>
                分機<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table20-->
        </div><!--con-->
      </div><!--area4-->
      <div class="area4">
        <div class="tit">保證人二</div>
        <div class="con">
          <table class="table table15">
            <tbody>
            <tr>
              <td width="120px">姓名：<span></span></td>
              <td width="200px">身分證字號：<span></span></td>
              <td  width="50px">
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>男
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>女
              </td>
              <td  width="105px">
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>已婚
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>未婚
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他
              </td>
              <td>
                生日：
<!--                <span class="nb">2023</span>/<span class="nb">12</span>/<span class="nb">30</span>-->
              </td>
              <td  width="110px" >關係：<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table15-->
          <table class="table table16">
            <tbody>
            <tr>
              <td>
                戶籍地址：
                <span></span>
                <span style="display:inline-block; width: 365px;"></span>
                電話：<span></span>
              </td>
              <td width="142px">身份證請領資料：
<!--                <span class="nb">2023</span>/<span class="nb">12</span>/<span class="nb">30</span>-->
              </td>
            </tr>
            <tr>
              <td>
                通訊地址：
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>同戶籍
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>其他
                <span style="margin-left:10px;"></span>
                <span style="display:inline-block; width: 275px; "></span>
                電話：<span></span>
              </td>
              <td>行動：<span></span></td>
            </tr>
            </tbody>
          </table><!--table16-->
          <table class="table table17">
            <tbody>
            <tr>
              <td>
                現住房屋已<span class="y"></span>年
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>自有\配偶所有
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>父母/子女所有
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>租賃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他(<span class="others1"></span>)
              </td>
              <td width="245px">學歷
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>博士
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>研究所
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>大專
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>高中職
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>初中及以下
              </td>
              <td width="110px">
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>領有殘障手冊<br/>
                (<span class="others2"></span>)

              </td>
            </tr>
            </tbody>
          </table><!--table17-->
          <table class="table table18">
            <tbody>
            <tr>
              <td width="252px">
                服務單位：<span></span>
              </td>
              <td >
                服務單位性質：
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>上市/櫃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>未上市/櫃
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>獨資
                <span class="checkbox" style="margin-left:4px;"><input type="checkbox" disabled=""></span>軍公教
                <span class="checkbox" style="margin-left:2px;"><input type="checkbox" disabled=""></span>其他
              </td>
              <td width="110px">
                行業別：<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table18-->
          <table class="table table19">
            <tbody>
            <tr>
              <td width="140px">
                職稱：<span></span>
              </td>
              <td width="112px">
                年資：<span></span>
              </td>
              <td width="120px">
                月收入：<span></span>
              </td>
              <td>
                E-mail：<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table19-->
          <table class="table table20">
            <tbody>
            <tr>
              <td width="446px">
                服務地址：
                <span></span>
              </td>
              <td>
                電話：<span style="display: inline-block; width:107px;"></span>
                分機<span></span>
              </td>
            </tr>
            </tbody>
          </table><!--table20-->
        </div><!--con-->
      </div><!--area4-->
      <div class="area5">
        <div class="tit">聲明事項暨資料運用約定書</div>
        <div class="con">
          <ol class="ol1">
            <li>個人資料保護法告知事項如背面「遠東國際商業銀行履行個人資料保護法第八條第一項告知義務內容」所示，申請人(包括借款人、保證人，以下簡稱申請人等)就告知事項內容已知悉。</li>
            <li>申請人等同意 貴行、本公司/本人往來金融機構及財團法人金融聯合徵信中心依其營業登記項目或章程所定業務之需要等特定目的，得查詢、蒐集、處理及利用本公司/本人之各項資料(包括貴行得向財團法人金融聯合徵信中心為之);惟以法令及貴行須遵守之相關規定(如銀行公會、聯合徵信中心相關準則、規約等)未禁止者為限。</li>
            <li>申請人等同意合於 貴行營業登記項目或章程所定業務之需要等特定目的，得將本申請書填寫之個人資料提供 貴行、財團法人金融聯合徵信中心及金管會指定機構蒐集、處理及利用(包括提供 貴行作為內部行政研究或宣傳推廣或寄送消費資訊之用)。</li>
            <li>申請人等同意 貴行之交易帳款收付業務、(電腦)處理業務或其他與本貸款有關之附隨業務(包括但不限於資訊系統之資料登錄、處理及輸出，資訊系統之開發、監控及維護，客戶資料輸入，表單列印、裝封及付交郵寄，表單、憑證等資料保存，帳款催收及法律程序，車輛協尋、取回與拍賣作業，汽車貸款行銷及貸放作業管理(不含授信審核之准駁)、 服務及諮詢等作業及其他經金管會核定得委外之作業項目等「含符合特定目的之相關個人資料蒐集、處理及利用」)，於必要時得依金管會規定或經金管會核准，委託適當之第三人機構合作辦理。</li>
            <li>申請人等了解，為便利申貸作業，本申請書及申貸相關資料將由合迪人員代為收取，且申請人等亦了解 貴行之車輛貸款行銷作業係委託合迪處理。</li>
            <li>申請人等聲明已了解本申請書內容，且切結上述資料均填載屬實，並願同意共同遵守本申請書之各項條款及約定事項。</li>
          </ol><!--ol1-->
          <div class="txt1">此致&nbsp;遠東國際商業銀行股份有限公司</div>
          <div class="txt2">本申請書限申請遠銀策盟車貸使用，不得移作他用</div>
          <div class="txt3">
            <span>借款人(簽章)</span>
            <span>保證人(簽章)</span>
          </div>
        </div><!--con-->
      </div><!--area5-->
      <div class="ft">SA_FIN 112年10月版(合迪重/小車)</div>
    </div><!--page1-->
    <div class="page page2">
      <div class="area6">
        遠東國際商業銀行履行個人資料保護法第八條第一項告知義務內容<br/>
        <ul >
          <li>ㄧ、親愛的客戶您好，由於個人資料之蒐集，涉及 臺端的隱私權益，遠東國際商業銀行股份有限公司( 以下稱本行) 向 臺端蒐集個人資料時，依據個人資料保護法( 以下稱個 資法)第八條第一項規定，應明確告知 臺端下列事項:(一)非公務機關名稱(二)蒐集之目的(三)個人資料之類別(四)個人資料利用之期間、地區、對象及方式(五)當事 人依個資法第三條規定得行使之權利及方式(六)當事人得自由選擇提供個人資料時，不提供將對其權益之影響。此外，當 臺端具有歐盟國籍或居住地於歐盟，則依循歐盟一 般資料保護規範(General Data Protection Regulation,GDPR)要求於特定目的內蒐集、處理及利用 臺端之個人資料。</li>
          <li>二、有關本行蒐集 臺端個人資料之目的、個人資料類別及個人資料利用之期間、地區、對象及方式等內容，請 臺端詳閱如後附表。</li>
          <li>三、依據個資法第三條規定，臺端就本行保有 臺端之個人資料得行使下列權利:</li>
          <ul class="ul2">
            <li><span class="tit">(一)</span>除有個資法第十條所規定之例外情形外，得向本行查詢、請求閱覽或請求製給複製本，惟本行依個資法第十四條規定得酌收必要成本費用。</li>
            <li><span class="tit">(二)</span>得向本行請求補充或更正，惟依個資法施行細則第十九條規定，臺端應適當釋明其原因及事實。</li>
            <li><span class="tit">(三)</span>本行如有違反個資法規定蒐集、處理或利用 臺端之個人資料，依個資法第十一條第四項規定，臺端得向本行請求停止蒐集。</li>
            <li><span class="tit">(四)</span>依個資法第十一條第二項規定，個人資料正確性有爭議者，得向本行請求停止處理或利用 臺端之個人資料。惟依該項但書規定，本行因執行業務所必須並註明其爭議或經 臺端書面同意者，不在此限。</li>
            <li><span class="tit">(五)</span>依個資法第十一條第三項規定，個人資料蒐集之特定目的消失或期限屆滿時，得向本行請求刪除、停止處理或利用 臺端之個人資料。惟依該項但書規定，本行因執行業務 所必須或經 臺端書面同意者，不在此限。</li>
          </ul>
          <li>四、臺端得自由選擇是否提供相關個人資料及類別，惟</li>
          <ul class="ul2">
            <li><span class="tit">(一)</span>臺端所拒絕提供之個人資料及類別，如果是辦理業務審核或作業所需之資料，本行可能無法進行必要之業務審核或作業而無法提供 臺端相關服務或無法提供較佳之服務。</li>
            <li><span class="tit">(二)</span>關於本行遵循美國海外帳戶稅收遵循法條款之特定目的需蒐集、處理及利用 臺端之個人資料，如 臺端不同意提供或提供資料不足，本行必須依美國海外帳戶稅收遵循法之規定將 臺端帳戶列為「不合作帳戶」(Recalcitrant Account)，而須依法對特定帳戶存入款項扣繳百分之三十之美國稅款;如經合理期間內與 臺端聯繫仍未獲 臺端同意或 臺端提供資料仍有不足，本行須依法關閉台端之帳戶。</li>
            <li><span class="tit">(三)</span>關於本行遵循歐盟一般資料保護規範(GDPR)僅適用資料得行使下列權利:</li>
            <li>
              <ol style="margin: 5px 0 0;">
                <li>行使我國個人資料保護法的當事人權利。</li>
                <li>資料限制處理權。</li>
                <li>資料可攜權。</li>
                <li>停止自動化決策及資料剖析。</li>
              </ol>
            </li>
          </ul>
          <li>本行最新之告知義務內容，以及臺端如欲行使上述個資法第三條規定及歐盟一般資料保護規範(GDPR)之前述權利，有關如何行使之方式，得於本行網站(網址: http://www.feib.com.tw)查詢。</li>
        </ul>
      </div><!--area6-->
      <div class="area7">
        <div class="tit">附表:</div>
        <table class="tablePS">
          <thead>
          <tr>
            <th colspan="3">特定目的說明</th>
            <th rowspan="2"  width="133px">蒐集之個人資料類別</th>
            <th rowspan="2"  width="68px">個人資料<br/>利用之期間</th>
            <th rowspan="2"  width="68px">個人資料<br/>利用之地區</th>
            <th rowspan="2"  width="103px">個人資料<br/>利用之對象</th>
            <th rowspan="2">個人資料<br/>利用之方式</th>
          </tr>
          <tr>
            <th width="57px">業務類別</th>
            <th width="178px">業務特定目的及代號</th>
            <th width="87px">共通特定目的及代號</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>一、存匯業務</th>
            <td>
              <div class="item"><span class="nb">022</span><span>外匯業務</span></div>
              <div class="item"><span class="nb">035</span><span>存款保險業務</span></div>
              <div class="item"><span class="nb">036</span><span>存款與匯款業務</span></div>
              <div class="item"><span class="nb">067</span><span>信用卡、現金卡、轉帳<br/>&nbsp;卡或電子票證業務</span></div>
              <div class="item"><span class="nb">082</span><span>借款戶與存款戶存借<br/>&nbsp;作業綜合管理</span></div>
              <div class="item"><span class="nb">112</span><span>票據交換業務</span></div>
              <div class="item"><span class="nb">181</span><span>其他經營合於營業登記項目或組織章程所 定之業務</span></div>
            </td>
            <td rowspan="9">
              <div class="item"><span class="nb">040</span><span class="con1">行銷</span></div>
              <div class="item"><span class="nb">059</span><span class="con1">金融服務業依法令規定及金融監理需要，所為之蒐集處理及利用</span></div>
              <div class="item"><span class="nb">060</span><span class="con1">金融爭議處理</span></div>
              <div class="item"><span class="nb">063</span><span class="con1">非公務機關依法定義務所進行個人資料之蒐集處理及利用</span></div>
              <div class="item"><span class="nb">069</span><span class="con1">契約、類似契約 或其他法律關係管理之事務</span></div>
              <div class="item"><span class="nb">090</span><span class="con1">消費者、客戶管理與服務</span></div>
              <div class="item"><span class="nb">091</span><span class="con1">消費者保護</span></div>
              <div class="item"><span class="nb">098</span><span class="con1">商業與技術資訊</span></div>
              <div class="item"><span class="nb">104</span><span class="con1">帳務管理及債權交易業務</span></div>
              <div class="item"><span class="nb">136</span><span class="con1">資(通)訊與資料庫管理</span></div>
              <div class="item"><span class="nb">137</span><span class="con1">資通安全與管理</span></div>
              <div class="item"><span class="nb">157</span><span class="con1">調查、統計與研究分析</span></div>
              <div class="item"><span class="nb">182</span><span class="con1">其他諮詢與顧問服務</span></div>
            </td>
            <td>
              姓名、身分證統一編號、性別、出生年月日、通訊方式及其他詳如相關業務申請書或契約書之內容，並以本行與客戶往來之相關業務、帳戶或服務及自客戶或第三人處(例 如:財團法人金融聯合徵信中心)所實際蒐集之個人資料為準。
            </td>
            <td rowspan="9">
              <ol class="ol">
                <li>特定目的存續期間。</li>
                <li>依相關法令所定(例如商業會計法等)或因執行業務所必須之保存期間或本行所訂之資料保存期間或依個別契約就資料之保存所定之保存年限。(以期限最長者為準)</li>
              </ol>
            </td>
            <td rowspan="9">右邊「個人資料利用之對象」欄位所列之利用對象其國內及國外所 在地</td>
            <td rowspan="7">
              <ol class="ol">
                <li>本行(含受本行委託處理事務之委外機構)。</li>
                <li>依法令規定利用之機構。</li>
                <li>其他業務相關之機 構(例如:通匯行、財團法人金融聯合徵信中心、財團法人聯合信用卡處理中心、台灣票據交換所、財金資訊股份有限公司、信用保證機構、信用卡國際組織、收單機構暨特約商店等)。</li>
                <li>依法有權機關或金融監理機關。</li>
                <li>客戶所同意之對象(例如本行共同行銷或交互運用客戶資料之公司、與本行合作推廣業務之公司等)。</li>
                <li>其他與本行有業務往來之機構。</li>
              </ol>
            </td>
            <td rowspan="9">符合個人資料保護相關法令以自動化機器或其他非自動化之利用方式。</td>
          </tr>
          <tr>
            <th>二、授信業務</th>
            <td>
              <div class="item"><span class="nb">022</span><span>外匯業務</span></div>
              <div class="item"><span class="nb">067</span><span>信用卡、現金卡、轉帳卡或電子票證業務</span></div>
              <div class="item"><span class="nb">082</span><span>借款戶與存款戶存借作業綜合管理</span></div>
              <div class="item"><span class="nb">088</span><span>核貸與授信業務</span></div>
              <div class="item"><span class="nb">106</span><span>授信業務</span></div>
              <div class="item"><span class="nb">111</span><span>票券業務</span></div>
              <div class="item"><span class="nb">126</span><span>債權整貼現及收買業務</span></div>
              <div class="item"><span class="nb">154</span><span>徵信</span></div>
              <div class="item"><span class="nb">181</span><span>其他經營合於營業登記項目或組織章程所定之業務</span></div>
            </td>
            <td>姓名、身分證統一編號、性別、出生年月日、通訊方式及其他詳如相關 業務申請書或契約書之內容，並以本行與客戶往來之相關業務、帳戶或服務及自客戶或第三人處(例如:財團法人金融聯合徵信中心)所實際蒐集之個人資料為準。</td>
          </tr>
          <tr>
            <th>三、信用卡業務</th>
            <td>
              <div class="item"><span class="nb">022</span><span>外匯業務</span></div>
              <div class="item"><span class="nb">067</span><span>信用卡、現金卡、轉帳卡或電子票證業務</span></div>
              <div class="item"><span class="nb">082</span><span>借款戶與存款戶存借作業綜合管理</span></div>
              <div class="item"><span class="nb">088</span><span>核貸與授信業務</span></div>
              <div class="item"><span class="nb">106</span><span>授信業務</span></div>
              <div class="item"><span class="nb">154</span><span>徵信</span></div>
              <div class="item"><span class="nb">181</span><span>其他經營合於營業登記項目或組織章程所定之業務</span></div>
            </td>
            <td>姓名、身分證統一編號、性別、出生年月日、通訊方式及其他詳如相關 業務申請書或契約書之內容，並以本行與客戶往來之相關業務、帳戶或服務及自客戶或第三人處(例 如:財團法人金融聯合徵信中心)所實際蒐集之個人資料為準。</td>
          </tr>
          <tr>
            <th>四、外匯業務</th>
            <td>
              <div class="item"><span class="nb">022</span><span>外匯業務</span></div>
              <div class="item"><span class="nb">036</span><span>存款與匯款業務</span></div>
              <div class="item"><span class="nb">082</span><span>借款戶與存款戶存借作業綜合管理</span></div>
              <div class="item"><span class="nb">088</span><span>核貸與授信業務</span></div>
              <div class="item"><span class="nb">106</span><span>授信業務</span></div>
              <div class="item"><span class="nb">154</span><span>徵信</span></div>
              <div class="item"><span class="nb">181</span><span>其他經營合於營業登記項目或組織章程所定之業務</span></div>
            </td>
            <td>姓名、身分證統一編號、性別、出生年月日、通訊方式及其他詳如相關 業務申請書或契約書之內容，並以 本行與客戶往來之相關業務、帳戶 或服務及自客戶或第三人處(例 如:財團法人金融聯合徵信中心) 所實際蒐集之個人資料為準。</td>
          </tr>
          <tr>
            <th>五、有價證券業務</th>
            <td>
              <div class="item"><span class="nb">111</span><span>票券業務</span></div>
              <div class="item"><span class="nb">037</span><span>有價證券與有價證券持有人登記</span></div>
              <div class="item"><span class="nb">044</span><span>投資管理</span></div>
              <div class="item"><span class="nb">082</span><span>借款戶與存款戶存借作業綜合管理</span></div>
              <div class="item"><span class="nb">088</span><span>核貸與授信業務</span></div>
              <div class="item"><span class="nb">106</span><span>授信業務</span></div>
              <div class="item"><span class="nb">154</span><span>徵信</span></div>
              <div class="item"><span class="nb">181</span><span>其他經營合於營業登記項目或組織章程所定之業務</span></div>
            </td>
            <td>姓名、身分證統一編號、性別、出生年月日、通訊方式及其他詳如相關 業務申請書或契約書之內容，並以 本行與客戶往來之相關業務、帳戶 或服務及自客戶或第三人處(例 如:財團法人金融聯合徵信中心) 所實際蒐集之個人資料為準。</td>
          </tr>
          <tr>
            <th>六、財富管理業務</th>
            <td>
              <div class="item"><span class="nb">022</span><span>外匯業務</span></div>
              <div class="item"><span class="nb">036</span><span>存款與匯款業務</span></div>
              <div class="item"><span class="nb">044</span><span>投資管理</span></div>
              <div class="item"><span class="nb">068</span><span>信託業務</span></div>
              <div class="item"><span class="nb">082</span><span>借款戶與存款戶存借作業綜合管理</span></div>
              <div class="item"><span class="nb">166</span><span>證券、期貨、證券投資信託及顧問相關業務</span></div>
              <div class="item"><span class="nb">094</span><span>財產管理</span></div>
              <div class="item"><span class="nb">181</span><span>其他經營合於營業登記項目或組織章程所定之業務</span></div>
            </td>
            <td>姓名、身分證統一編號、性別、出生年月日、通訊方式及其他詳如相關 業務申請書或契約書之內容，並以 本行與客戶往來之相關業務、帳戶 或服務及自客戶或第三人處(例 如:財團法人金融聯合徵信中心) 所實際蒐集之個人資料為準。</td>
          </tr>
          <tr>
            <th>七、其他</th>
            <td>
              <div class="item"><span class="nb">166</span><span>證券、期貨、證券投資信託及顧問相關業務</span></div>
              <div class="item"><span class="nb">181</span><span style="width:150px;">其他經營合於營業登記項目或組織章程所定之業務，或經中央主管機關核准辦理之其 他有關業務(例如:保管箱業務、黃金存摺業務、電子金融業務、代理收付業務、共同行銷或合作推廣業務、衍生性金融商品業務等)</span></div>
            </td>
            <td>姓名、身分證統一編號、性別、出生年月日、通訊方式及其他詳如相關 業務申請書或契約書之內容，並以 本行與客戶往來之相關業務、帳戶 或服務及自客戶或第三人處(例 如:財團法人金融聯合徵信中心) 所實際蒐集之個人資料為準。</td>
          </tr>
          <tr>
            <th>八、美國海外帳戶稅收遵循法遵循業務(為辨識美國稅務居民身分別，暨向美國當局或其他法定對象申報美國稅務居民海外帳戶資料之相關業務)</th>
            <td>
              <div class="item"><span class="nb">059</span><span style="width:150px;">金融服務業依法令( 包含美國海外稅收遵循法)規定及金融監理需要，所為之蒐集處理及利用</span></div>
              <div class="item"><span class="nb">060</span><span>金融爭議處理</span></div>
              <div class="item"><span class="nb">063</span><span style="width:150px;">非公務機關依法定義務所進行個人資料之蒐集處理及利用</span></div>
              <div class="item"><span class="nb">069</span><span>契約、類似契約或其他法律關係管理之事務</span></div>
              <div class="item"><span class="nb">090</span><span>消費者、客戶管理與服務</span></div>
              <div class="item"><span class="nb">091</span><span>消費者保護</span></div>
              <div class="item"><span class="nb">095</span><span>財稅行政</span></div>
              <div class="item"><span class="nb">098</span><span>商業與技術資訊</span></div>
              <div class="item"><span class="nb">104</span><span>帳務管理及債權交易業務</span></div>
              <div class="item"><span class="nb">136</span><span>資(通)訊與資料庫管理</span></div>
              <div class="item"><span class="nb">157</span><span>調查、統計與研究分析</span></div>
            </td>
            <td>姓名、國籍、身分證統一編號、性別、出生年月日、通訊方式、稅籍編號、移民情形、旅行及其他遷徙細節及其他詳如相關業務申請書或契約書 之內容，並以本行與臺端或臺端實 質所有之法律實體往來之相關業 務、帳戶或服務及自臺端或第三人處(如臺端為本行客戶，則包含財團 法人金融聯合徵信中心)所實際蒐集之個人資料類別為準。</td>
            <td>
              ㄧ、本行(含受本行委 託處理事務之委外機 構)。 <br/>二、依國內外法令規定 處理利用之機構(例 如:本行母公司、所屬 金融控股公司及關係金 融機構等)。<br/>
              三、依國內外法令之有 權機關、金融監理機關 或稅務機關(含美國聯 邦政府財政部)。<br/>
              四、其他台端所同意之 對象。
            </td>
          </tr>
          <tr>
            <th>九、GDPR適用對象之相關業務</th>
            <td>
              <div class="item"><span class="nb">022</span><span>外匯業務</span></div>
              <div class="item"><span class="nb">035</span><span>存款保險業務</span></div>
              <div class="item"><span class="nb">036</span><span>存款與匯款業務</span></div>
              <div class="item"><span class="nb">037</span><span>有價證券與有價證券持有人登記</span></div>
              <div class="item"><span class="nb">044</span><span>投資管理</span></div>
              <div class="item"><span class="nb">067</span><span>信用卡、現金卡、轉帳卡或電子票證業務</span></div>
              <div class="item"><span class="nb">068</span><span>信託業務</span></div>
              <div class="item"><span class="nb">082</span><span>借款戶與存款戶存借作業綜合管理</span></div>
              <div class="item"><span class="nb">088</span><span>核貸與授信業務</span></div>
              <div class="item"><span class="nb">094</span><span>財產管理</span></div>
              <div class="item"><span class="nb">106</span><span>授信業務</span></div>
              <div class="item"><span class="nb">111</span><span>票券業務</span></div>
              <div class="item"><span class="nb">112</span><span>票據交換業務</span></div>
              <div class="item"><span class="nb">126</span><span>債權整貼現及收買業務</span></div>
              <div class="item"><span class="nb">154</span><span>徵信</span></div>
              <div class="item"><span class="nb">166</span><span>證券、期貨、證券投資信託及顧問相關業務</span></div>
              <div class="item"><span class="nb">181</span><span>其他經營合於營業登記項目或組織章程所定之業務</span></div>
            </td>
            <td>姓名、國籍、身分證統一編號、性別、出生年月日、通訊方式及其他詳如 相關業務申請書或契約書之內容， 並以本行與客戶往來之相關業務、 帳戶或服務及自客戶或第三人處 (例如:財團法人金融聯合徵信中心)所實際蒐集之個人資料為準。</td>
            <td>「個人資料利用之對象」與業務類別一至八相同。</td>
          </tr>
          </tbody>
        </table><!--tablePS-->
        <div class="ft">SA_FIN 112年10月版(合迪重/小車)</div>
      </div><!--area7-->

    </div><!--page2-->

  </div><!--wrapper-->
</div>
</template>

<style scoped src="../../assets/css/finatrade_moto_print.css">

</style>



// WEBPACK FOOTER //
// src/pages/web/FinatradeMotoPrint.vue